<template>
  <v-app class="mutant">
    <v-app-bar app fixed max-width="768" class="mx-auto" :prominent="prominent">
      <template slot="img">
        <v-img alt="Mutant logo" src="./assets/fyndtabell-logo.png" :height="prominent ? 128 : 56"/>
      </template>
    </v-app-bar>
    <v-main>
      <v-container fluid app>
        <p class="text-subtitle-1 black pa-4">Du trevar försiktgt omkring med dina händer och plötsligt känner du ...</p>
        <BargainItem />
      </v-container>
      <v-footer app fixed class="caption">version {{ appVersion }}</v-footer>
    </v-main>
  </v-app>
</template>
<script>
import BargainItem from './components/BargainItem.vue'

export default {
  name: 'App',
  components: {
    BargainItem
  },
  data () {
    return {
      prominent: false,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION
    }
  },
  watch: {
    windowWidth(newWidth) {
      this.prominent = false

      if (newWidth > 768) {
        this.prominent = true
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      if (window.innerWidth > 768) this.prominent = true
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
<style lang="scss">
body {
  background-color: #222;
}
#app {
  font-family: Roboto;
  max-width: 768px;
  margin: auto;
}

.mutant {
  .v-toolbar__content {
    padding: 0;
  }
  .black {
    opacity: .8;
  }
  .v-card__title {
    word-break: normal;
  }
  background: url('./assets/background-bw.jpg') !important;
  background-size: cover !important;
}
.container {
  height: 100vh;
  background-color: #f3c60066;
}
</style>
